<hyperkit-typography variant="body1" align="left" [color]="color"><div [innerHTML]="html"></div>
</hyperkit-typography>
